import {USER_EVENTS,} from '../../../../events/events';
import BaseComponent from '../../../../base/base_component';
import {NAVIGATION_VIEWS} from "../../../external_links/external_links_consts";
let view = require('./view/netherlands_responsible_gaming_icons.html');

export default class NetherlandsResponsibleGamingIconsController extends BaseComponent {
    static CLASS = 'NetherlandsResponsibleGamingIconsController';

    _model = null;

    start() {
        let bakedHTML = this.bake(view);
        this.setHTML(bakedHTML);
        this._subscribe();
        return this;
    }


    _subscribe() {
        this.onDOMEvent(this.getDOMElementByClassName('cgp-themes-nl-resp-game-ksa'), USER_EVENTS.ON_CLICK, () => {
            this._sendAnalytics('ksa_click');
            this.serviceFactory.regulationService().getRegulation().openSelfTest(NAVIGATION_VIEWS.WINDOW);
        });

    }

    _sendAnalytics(label) {
        this.serviceFactory.analyticsService().sendClickstreamEvent(
            {
                eventName:'Orbit_User_Flow',
                category:'Navigation',
                action: 'Header',
                label:'Icon_' + label
            });
    }
}
